import { i18nLanguageToLocaleCode } from './constants/languages';

export function getLanguageCode(localeCode: string | undefined) {
  return localeCode?.split(/[-_]/)[0];
}

export function getCountryCode(localeCode: string | undefined) {
  const parts = localeCode?.split(/[-_]/);

  // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  return parts?.length > 1 ? parts[1] : null;
}

type KeyOfI18nLanguageToLocalCode = keyof typeof i18nLanguageToLocaleCode;

export function getAvailableI18nLanguage(localeCode: string | undefined) {
  const languageCode = getLanguageCode(localeCode);

  return (
    i18nLanguageToLocaleCode[localeCode as KeyOfI18nLanguageToLocalCode] ||
    i18nLanguageToLocaleCode[languageCode as KeyOfI18nLanguageToLocalCode] ||
    i18nLanguageToLocaleCode.en
  );
}
